const string2ArrayBuffer = (str) => {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
        bufView[i] = str.charCodeAt(i);
    }
    return buf;
};
const isArrayBuffersEqual = (buffer1, buffer2) => {
    if (buffer1.byteLength !== buffer2.byteLength) {
        return false;
    }
    const view1 = new DataView(buffer1);
    const view2 = new DataView(buffer2);
    for (let i = 0; i < buffer1.byteLength; i++) {
        if (view1.getUint8(i) !== view2.getUint8(i)) {
            return false;
        }
    }
    return true;
};
const ArrayBufferToString = (buf) => String.fromCharCode.apply(null, Array.from(new Uint8Array(buf)));
const hexToArrayBuffer = (hexString) => {
    const buffer = new ArrayBuffer(hexString.length / 2);
    const uint8Array = new Uint8Array(buffer);
    for (let i = 0; i < hexString.length; i += 2) {
        const byteValue = parseInt(hexString.substr(i, 2), 16);
        uint8Array[i / 2] = byteValue;
    }
    return buffer;
};
export const arrayBufferToHex = (buffer) => {
    const byteArray = new Uint8Array(buffer);
    let hexString = '';
    for (let i = 0; i < byteArray.length; i++) {
        let hex = byteArray[i].toString(16);
        hex = hex.length === 1 ? '0' + hex : hex;
        hexString += hex;
    }
    return hexString;
};
const importPrivateKey = (buffer) => crypto.subtle.importKey('pkcs8', buffer, {
    name: 'RSASSA-PKCS1-v1_5',
    hash: 'SHA-1',
}, true, ['sign']);
const importPublicKey = (buffer) => crypto.subtle.importKey('spki', buffer, {
    name: 'RSASSA-PKCS1-v1_5',
    hash: 'SHA-1',
}, true, ['verify']);
const signBase64 = async (base64Key, data) => {
    const binaryString = atob(base64Key);
    const buffer1 = string2ArrayBuffer(binaryString);
    const key = await importPrivateKey(buffer1);
    const encodedData = new TextEncoder().encode(data);
    return crypto.subtle.sign({
        name: 'RSA-PSS',
        saltLength: 32,
    }, key, encodedData);
};
export const RSASign = async (hexKey, data) => {
    const key = await importPrivateKey(hexToArrayBuffer(hexKey));
    const encodedData = new TextEncoder().encode(data);
    return crypto.subtle.sign({
        name: 'RSASSA-PKCS1-v1_5',
        saltLength: 32,
    }, key, encodedData);
};
export const RSAVerify = async (hexKey, signBuffer, data) => {
    const publicKey = await importPublicKey(hexToArrayBuffer(hexKey));
    const encodedData = new TextEncoder().encode(data);
    return crypto.subtle.verify({
        name: 'RSASSA-PKCS1-v1_5',
        saltLength: 32,
    }, publicKey, signBuffer, encodedData);
};
const base64Key = 'MIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC/RNh/NMuzEbYzglg9Nn7P4I1TRNFy2KhqzXoWxH0EOb40J6odVNsQZOBeYxUCUd+otza86yGBDhsWT7z5h8yofnlDEnJN5QB6GV7KfJV0d7tHAGo6fiD/MRGarfBOSXmDtTMiSIHSEZMrh7ecnb8rRKeRrK8pd7kiUiSATf+iDRJ7DCbT8Rs4gY1UVkG7pJQzs9GhnwEcU6tHLeW5cFCXyW6DUnM2rTLdb6EyuKe5RQzvRn6xbm4Zdh51n1cP68mZhxuuH2wnFXuUzJl0KbRCrgX8MzrxfsEBe12Din6LQhOydy9cAKe4e4Gk3xDJ3EB84M3nX9l6CzxSFoCFJk6jAgMBAAECggEALTaVBtzwGhBhxaNWQIIVUAaA4eIusLtOdJDF/4PLGaicsa9+oxhgAGwYLbe2S6oW+Mb2hYn/jYZMGOYYgdP8KQhcmeJOauNrTXGZ2rvAiJuVBZ+vfMw7+Jcc1jevypHLy7qVr9D7/zBwXaXjXX5cplnAUstDTMYkWVyZjErj1uZfhJXyaCPcWgqX6RhfE7LKQRQ4+O66gNU3LA8mL1++jRGzcvzZ678UjaPbHkDSN8A44We01BQE3/947CeNPoJrvgC0uE/LM16MRSoR4YVJRoJ8BciSkCUTaRU8GMKr7XCrjMIewEMmv4DDu3/7cLKkJ89C6Jn5UxtRmrAM8wJLIQKBgQDjSeKqfGnbV2qdb2pTntFUBTfB9GBSiWfzM0SNyECHUt7geO5ZBai8uEiKn2ixOiaWF5o/DPnl0bWR3y43YEvEuGBpRYdiPyHy9qWRK2AR/tkVr2p6LvcldM/fvIXT3u3BRL54xAIojZ6aMnjiC6oW84JxXrIjqd4/HQrfwwIWnQKBgQDXbiWaQAadDAFKY24CZ1qFuDF31D98BAUqvOMoxalxJXL5Tqp7epGTvtNDOSeiirZISDqnfKZa3sgio0HXE1+aDp6e9XEMbn/NCNzzmis3H1lssXFMewRX1C2NznEOnMlM2ktDFH4VXaJ8S+84+hzuNKPJRLbuo+EHrwlBIRJWPwKBgHRoGfPRBnI1IkCBmIY9N959UaI/Y7nB8ABJyJmI7yufkNCMfx4O3O3SwCxnGjpymuKSMgiKv84pioGsOUJZSlT1TUN9PapexSdnlUJ1YZ211T7a+YCcXy3K1tAzAKOTcFdkutylHqngZlN4+BplePaKPsuLgVbsoAvY9wHFIWOtAoGAKblOlRpzbXVGxraNNu/3i1CKXDACf61zprxgrqPh1mUvaHPA9xtdGKVr22g1cfi1pzg+C/RLb+wYDQVbmiFJcdgFBrp4w7SfEgH2cUPZvNpYgoG3dN2akLwqen2STgc1wanBy+MrLE4vSy2Vzo46jjQpyLCDUaLx0YAoJbIXEBcCgYAxArBbpjpMJzTnH1mvSXZaOj41h7T75MZ4Ve4VsQqbNfDLDEr8NKp+T3kat/io8tFyN8bRQ4+Wbk2tcxeCbqFuyd90owDVcScqVGq/kAGhwsJX4bM1xGv8uecaCCypBeX4UNooCyVBYbYYM5AHQehgvMtPSJYMtnQdAMH0AlrMbQ==';
